<template>
    <div class="pageDiv">
        <v-card class="all-events-card">

            <v-card class="top-card">
                <!-- Slideshow container -->
                <div class="slideshow-container gallery-size">

                    <!-- Full-width images with number and caption text -->
                    <div class="mySlides fade" v-for="slide in slides_1" :key="slide">
                        <div class="numbertext">1 / 3</div>

                        <v-img class="numbertext" :src="getFileName(slide)">
                        </v-img>
                        <div class="text"></div>
                    </div>

                    <!-- Next and previous buttons -->
                    <a class="prev" @click="plusSlides(-1)">&#10094;</a>
                    <a class="next" @click="plusSlides(1)">&#10095;</a>
                </div>
                <br>

                <!-- The dots/circles -->
                <div style="text-align:center">
                    <span class="dot"
                          v-for="idx in slides_1.length" :key="idx"
                          @click="currentSlide2(idx+1)"
                    >
                    </span>
                </div>
            </v-card>
        </v-card>

    </div>
</template>

<script>
  export default {
    name: "home",
    data: () => ({
      gallery: false,
      slideIndex: 1,
      slides_1: []
    }),
    mounted: function() {
        this.showSlides(this.slideIndex);
    },
    methods: {
        printAgentInfo() {
          return window.navigator.userAgent + ' width: ' + window.innerWidth + ' height: ' + window.innerHeight;
        },

        // Next/previous controls
        plusSlides(n) {
          this.showSlides(this.slideIndex += n);
        },

        // Thumbnail image controls
        currentSlide(n) {
          this.showSlides(this.slideIndex = n);
        },
        currentSlide2(n) {
          console.log(n);
        },
        showSlides(n) {
          let i;
          let slides = document.getElementsByClassName("mySlides");
          let dots = document.getElementsByClassName("dot");
          if (n > slides.length) {this.slideIndex = 1}
          if (n < 1) {this.slideIndex = slides.length}
          for (i = 0; i < slides.length; i++) {
            slides[i].style.display = "none";
          }
          for (i = 0; i < dots.length; i++) {
            dots[i].className = dots[i].className.replace(" active", "");
          }
          slides[this.slideIndex-1].style.display = "block";
          dots[this.slideIndex-1].className += " active";
        },
        getFileName(imageName) {
          return "/images/gallery_1/" + imageName;
        }
    }
  }
</script>

<style scoped>

    .top-card {
        height: 420px !important;
    }

    @media (min-width: 768px) {
        .top-card {
            height: 700px !important;
        }
        .gallery-size {
            width: 800px !important;
            height: 600px !important;
            max-width: 800px;
            max-height: 600px;
            object-fit: fill !important;
            background-size: fill;
        }
    }

    ul {
        margin-top: 20px;
    }

    li {
        margin: 0 0 15px 20px;
    }

    * {box-sizing:border-box}

    /* Slideshow container */
    .slideshow-container {
      position: relative;
      margin: auto;
    }

    /* Hide the images by default */
    .mySlides {
      display: none;
    }

    /* Next & previous buttons */
    .prev, .next {
      cursor: pointer;
      position: absolute;
      top: 50%;
      width: auto;
      margin-top: -22px;
      padding: 16px;
      color: white;
      font-weight: bold;
      font-size: 18px;
      transition: 0.6s ease;
      border-radius: 0 3px 3px 0;
      user-select: none;
    }

    /* Position the "next button" to the right */
    .next {
      right: 0;
      border-radius: 3px 0 0 3px;
    }

    /* On hover, add a black background color with a little bit see-through */
    .prev, .next {
      background-color: rgba(0,0,0,0.8);
    }

    /* Caption text */
    .text {
      color: #f2f2f2;
      font-size: 15px;
      padding: 8px 12px;
      position: absolute;
      bottom: 8px;
      width: 100%;
      text-align: center;
    }

    /* Number text (1/3 etc) */
    .numbertext {
      color: #f2f2f2;
      font-size: 12px;
      padding: 8px 12px;
      position: absolute;
      top: 0;
    }

    /* The dots/bullets/indicators */
    .dot {
      cursor: pointer;
      height: 15px;
      width: 15px;
      margin: 0 2px;
      background-color: #bbb;
      border-radius: 50%;
      display: inline-block;
      transition: background-color 0.6s ease;
    }

    .active, .dot:hover {
      background-color: #717171;
    }

    /* Fading animation */
    .fade {
      animation-name: fade;
      animation-duration: 1.5s;
    }

    @keyframes fade {
      from {opacity: .4}
      to {opacity: 1}
    }

    .pics {
      border-radius: 7px;
      max-height: 100%;
      width: 100%;
      object-fit: fill !important;
    }
</style>